module.exports = __webpack_public_path__ + "static/hb_painting_05-2016-6ef13a4846d7a3ec709011d7547e837c.pdf";